<script>
import useValidation from "@/use/Validation";
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {useEvaluationInterviewStore} from "@/stores/Evaluation/EvaluationInterview";
import {computed, onMounted, ref} from "vue";
import axios from "axios";
import InterviewCore from "@/views/Evaluation/EvaluationInterview/Components/InterviewCore.vue";

export default {
    components: {InterviewCore},
    props: {
        updateAction: Boolean,
        deleteAction: Boolean,
        viewAction: Boolean,
        type: String,
        getIt: Boolean,

    },
    setup(props) {

        const {mxRules} = useValidation();
        const {dialog, loading} = useSharedData();
        const {getBack} = useSharedMethod();
        const {$refs, $route} = useTools();
        const evaluationInterviewStore = useEvaluationInterviewStore();

        const evaluationInterview = ref({
            note: 0,
            categories: [],
            questions: [],
            closed: false,
        });
        const closed = ref(false);

        const readonly = computed(() => props.viewAction || props.deleteAction);

        function generateInterview(id) {
            loading.value = true;
            axios.get(`/evaluationInterviews/generateInterview/${id}/${props.type}`).then((response) => {
                evaluationInterview.value = response.data;
                closed.value = evaluationInterview.value.closed;
            }).finally(() => {
                loading.value = false;
            });
        }

        function findById(id) {
            loading.value = true;
            axios.get(`/evaluationInterviews/${id}`).then((response) => {
                evaluationInterview.value = response.data;
                closed.value = evaluationInterview.value.closed;
            }).finally(() => {
                loading.value = false;
            });
        }

        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                evaluationInterview.value.type = props.type;
                evaluationInterview.value.closed = true;
                axios.post('/evaluationInterviews', evaluationInterview.value).then((response) => {
                    evaluationInterviewStore.updateEvaluationInterview(response.data);
                    evaluationInterviewStore.setRefresh();
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }


        onMounted(() => {
            if(props.getIt) {
                findById($route.params.id);
            } else {
                generateInterview($route.params.id);
            }
        });

        return {
            evaluationInterviewStore,
            mxRules,
            readonly,
            dialog,
            loading,
            evaluationInterview,
            closed,
            save,
            getBack,
        };
    }
}
</script>

<template>
    <v-dialog
        v-model="dialog"
        max-width="1500"
        persistent
        scrollable
    >
        <v-card>
            <w-dialog-toolbar
                :add-action="updateAction"
                :delete-action="deleteAction"
                :view-action="viewAction"
                :title="''"
            />
            <v-card-text>
                <v-container grid-list-md>
                    <v-form ref="form">
                        <interview-core
                            v-model="evaluationInterview"
                            :type="type"
                            :readonly="readonly || evaluationInterview.closed"
                        />
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close :loading="loading" @press="getBack"/>
                <w-btn
                    v-if="updateAction && !evaluationInterview.closed"
                    color="teal"
                    icon="mdi-database-plus"
                    :text="$t('common.validate')"
                    :loading="loading"
                    @press="save"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>